export enum PricelistPricesOrderingEnum {
  PricelistName = 'PricelistName',
  PricelistType = 'PricelistType',
  CostPrice = 'CostPrice',
  StartDate = 'StartDate',
}
